
import {CloseConversationModalProps} from './types'
import CloseConversationModalView from './CloseConversationView'
import React from 'react'
import {closeConversation} from '../../../actions/modal'
import {partChannel} from '../../../api/action/partChannel'
import {
    useAppDispatch,
} from '../../../hooks'

const CloseConversationModal = (props: CloseConversationModalProps): React.ReactElement => {
    const {channelId} = props
    const dispatch = useAppDispatch()

    const closeModal = () => {
        dispatch(closeConversation({show: false}))
    }

    const onSkip = () => {
        closeModal()
    }

    const onClose = () => {
        // close conversation
        dispatch(partChannel({channel_id: channelId}))
        closeModal()
    }
    return (
        <CloseConversationModalView
            onCancel={onSkip}
            onClose={onClose}
        />
    )
}
export default CloseConversationModal
